export class CompanySite{
    companyId : number;
    siteId : number;
    companyOwnerSharePercent: number;
    companyName: string;
    isSelected?: boolean;
}